import { extractPurchasePriceId, isPurchaseHandoffPath } from '@/lib/purchase-handoff-path';

export function getLoginReturnTo(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const returnTo = new URLSearchParams(window.location.search).get('returnTo');
  if (!returnTo || !returnTo.startsWith('/')) return undefined;
  return returnTo;
}

export function isPurchaseLoginFlow(): boolean {
  return isPurchaseHandoffPath(getLoginReturnTo());
}

const PENDING_PURCHASE_PRICE_ID_KEY = 'harry_pending_purchase_price_id';

/**
 * Stash the priceId from a `/purchase?priceId=…` returnTo so whichever
 * completeLogin() call ends up minting the session (Google popup/redirect or
 * email-link — all converge on AuthContext's Firebase auth listener, not this
 * page) can send it to the server. The server re-validates it independently
 * (AUD-02: only a server-revalidated priceId can waive the invited check —
 * never a caller-supplied boolean/flag).
 */
export function rememberPendingPurchasePriceId(returnTo: string | undefined): void {
  if (typeof window === 'undefined') return;
  const priceId = extractPurchasePriceId(returnTo);
  if (!priceId) return;
  window.sessionStorage.setItem(PENDING_PURCHASE_PRICE_ID_KEY, priceId);
}

export function getPendingPurchasePriceId(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  return window.sessionStorage.getItem(PENDING_PURCHASE_PRICE_ID_KEY) ?? undefined;
}

export function clearPendingPurchasePriceId(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(PENDING_PURCHASE_PRICE_ID_KEY);
}

/** @deprecated Use completeLogin from @/lib/access/client — body is idToken only. */
export function buildLoginBody(idToken: string): { idToken: string } {
  return { idToken };
}
